<div class="flex flex-col gap-6">
  @if (loading()) {
    <flx-spinner
      class="my-4"
      size="small"
      text="Copying resources..."
    />
  } @else if (error) {
    <div class="flex gap-10 flex-col items-center">
      <div>
        <div class="text-2xl text-center font-bold">Copy Resource Failed</div>
        <div class="text-sm text-neutral-500 text-center">
          Some errors occurred during the copy process. Retry or cancel to exit — no resources will
          be copied if you exit.
        </div>
      </div>
      <flx-icon
        name="deleted-box"
        class="w-[70px] h-[70px] text-neutral-200 stroke-none"
      />
      <div class="w-full flex justify-between">
        <button
          (click)="closeModal()"
          class="w-full border-0 text-red-500"
          data-testId="cancel-button"
          flxButton
          type="button"
          variant="ghost"
        >
          <i class="ph ph-trash"></i>
          Cancel and exit
        </button>
        <button
          (click)="copyResource()"
          class="w-full text-white border-transparent bg-blue-500 disabled:opacity-35"
          data-testId="save-dependency-button"
          flxButton
        >
          Retry
        </button>
      </div>
    </div>
  }
</div>
